import React from 'react';
import { IconProps } from '.';

const SvgColoredMegaphone = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#91D6A7'
        d='m18.35 17.183-9.097-3.466.034-6.276 9.13-3.364a1.219 1.219 0 0 1 1.643 1.155l-.057 10.83c0 .85-.86 1.438-1.654 1.133v-.012Z'
      />
      <path
        fill='#5AC27C'
        d='M6.15 7.43h3.137l-.034 6.298H6.115A3.187 3.187 0 0 1 3 10.545c0-1.733 1.416-3.127 3.15-3.127v.012Z'
      />
      <path
        fill='#23AE50'
        d='M9.865 20.899H8.132a.895.895 0 0 1-.861-.691l-1.586-6.502 3.59.022L10.76 19.8a.913.913 0 0 1-.657 1.087c-.068.023-.147.023-.215.023l-.023-.011Z'
      />
    </svg>
  );
};

export default SvgColoredMegaphone;
